


















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  @Prop() appId!: number;

  option: any = {
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c}单 ({d}%)"
    },
    legend: {
      orient: "vertical",
      x: "left",
      data: []
    },
    series: [
      {
        type: "pie",
        radius: "55%",
        center: ["50%", "60%"],
        label: {
          // normal: {
            // position: 'inner',
            formatter: "{b} \n {c}单（{d}%）"
          // }
        },
        data: []
      }
    ]
  };

  ei: any = {};

  // echartsTheme: {} = tdTheme;

  async loadData(params?: any) {
    const res2 = await this.$store.dispatch("workorders/chartsdata", {
      app_id: this.appId,
      ...params
    });
    if (res2 && res2.Data) {
      this.option.series[0].data = [];
      this.option.legend.data = [];

      this.option.series[0].data = res2.Data;

      for (const obj of res2.Data) {
        this.option.legend.data.push(obj.name);
      }
    } else {
      this.option.series[0].data = [];
      this.option.legend.data = [];
    }
  }

  mounted() {
    this.loadData();
  }

  changeDate(dates: any[], dateStrings: any[]) {
    this.loadData({
      start_time: `${dateStrings[0]} 00:00:00`,
      end_time: `${dateStrings[1]} 23:59:59`
    });
  }
}
